import React, { PureComponent } from 'react'
import SModal from 'components/sModal'
//import SButton from 'components/sButton'
import { connect } from 'react-redux'
//import {Toast} from 'helpers/iziToast';
import {getHost} from '../../../configs/index';
import './styles.css'

class PaymentStep extends PureComponent {
  constructor(props){
    super(props)

    this.state = {
      loading: true,
      error: false,
      link: ''
    }
  }

  componentDidMount = () => {
    const url = getHost + '/api/create-charge/' + this.props.user.id
    fetch(url)
      .then(resJSON => resJSON.json())
      .then(res => {
        this.setState({ loading: false, link: res.coinbaseLink })
      })
      .catch(() => this.setState({ loading: false, error: true }))
  }

  payClicked = (e) => this.state.loading && e.preventDefault()

  render() {

    const { loading, error, link } = this.state
    const { closeModal } = this.props

  	return(
  		<SModal.Main onClose={closeModal} noHead={true} closeOnOutsideClick={true} title='EDIT COIN' >
  			<SModal.Body>
          <fb className="paymentStepMain">
            <fb className="title">Complete Payment</fb>
            <fb className="infoText">Pay 99 $ in crypto for one year of premium data.</fb>
            <fb className="infoTextExtra">Payable in BTC, ETH, BCH, LTC</fb>
  					<fb className='signupBox'>
              { error
                  ? <fb className="errorBar">There was an error, please try again later.</fb>
                  : <a className="checkoutBtn" href={link} target="_blank" onClick={this.payClicked}>{ loading ? '...' : 'Pay With Coinbase Commerce' }</a>
              }
  					</fb>
  				</fb>
  			</SModal.Body>
  		</SModal.Main>
  	)
  }
}

const mapStateToProps = (state: Store) => ({
  user: state.user
})

export default connect(mapStateToProps)(PaymentStep)



// WEBPACK FOOTER //
// ./src/modals/signupModal/paymentStep/index.js